import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../../config/NaeSSchema";

class TruckModel extends Model {
  static reducer(action, TruckModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Truck.schema:
        action.payload.forEach((payload) => {
          const dbData = TruckModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          TruckModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
TruckModel.modelName = "TruckModel";

TruckModel.fields = {
  id: attr(),
};

export default TruckModel;